import { PlanPackage, PlanStats } from './types';

export const mockPlans: PlanPackage[] = [
    {
        id: 1,
        name: "TRADER",
        description: "BeQs Reward mang đến cơ hội đầu tư an toàn với lợi nhuận hấp dẫn qua gói đầu tư giáo dục chất lượng cao.",
        price: "13000000.00",
        total_slots: 68,
        used_slots: 41,
        monthly_commission_rate: "1.00",
        commission_rate: "10.00",
        commission_start_month: 4,
        duration_months: 0,
        min_profit_rate: "0.00",
        is_active: true,
        created_at: "2026-01-09T14:35:52.000000Z",
        updated_at: "2026-01-09T14:35:57.000000Z",
        image: null,
        part_per_user: 0,
        high_profit_rate: "4.00",
        high_rate_duration: 3,
        tax_rate: "10.00",
        phases: [
            {
                id: 1,
                phase_number: 1,
                title: "Xây dựng nền tảng",
                duration: "Tháng 1-12",
                description: "Phát triển hệ thống quản lý học viện, tuyển dụng 50 giảng viên chất lượng cao, mở 10 trung tâm đầu tiên"
            }
        ],
        benefits: [
            { id: 1, description: "Báo cáo doanh thu chi tiết hàng tháng với breakdown theo từng trung tâm" },
            { id: 2, description: "Dashboard theo dõi realtime số lượng học viên, doanh thu, lợi nhuận" },
            { id: 3, description: "Quyền tham dự Đại hội đối tác hàng quý tại khách sạn 5 sao" }
        ]
    },
    {
        id: 2,
        name: "PIONEER",
        description: "Gói đầu tư cao cấp với cam kết lợi nhuận ổn định và hoa hồng F1 hấp dẫn.",
        price: "300000000.00",
        total_slots: 30,
        used_slots: 12,
        monthly_commission_rate: "3.00",
        commission_rate: "10.00",
        commission_start_month: 1,
        duration_months: 36,
        min_profit_rate: "3.00",
        is_active: true,
        created_at: "2026-01-10T10:00:00.000000Z",
        updated_at: "2026-01-10T10:00:00.000000Z",
        image: null,
        part_per_user: 6,
        high_profit_rate: "5.00",
        high_rate_duration: 6,
        tax_rate: "10.00",
        phases: [
            {
                id: 1,
                phase_number: 1,
                title: "Xây dựng nền tảng",
                duration: "Tháng 1-12",
                description: "Phát triển hệ thống quản lý học viện, tuyển dụng giảng viên"
            },
            {
                id: 2,
                phase_number: 2,
                title: "Mở rộng quy mô",
                duration: "Tháng 13-24",
                description: "Tăng lên 30 trung tâm toàn quốc, đào tạo 20,000 học viên"
            },
            {
                id: 3,
                phase_number: 3,
                title: "Tối ưu và Scale",
                duration: "Tháng 25-36",
                description: "Đạt 50 trung tâm, 50,000 học viên tích lũy, launch nền tảng học online"
            }
        ],
        benefits: [
            { id: 1, description: "Báo cáo doanh thu chi tiết hàng tháng" },
            { id: 2, description: "Dashboard theo dõi realtime" },
            { id: 3, description: "Quyền tham dự Đại hội đối tác hàng quý" },
            { id: 4, description: "Ưu tiên cho người thân tham gia các khóa học với giảm giá 50%" }
        ]
    },
    {
        id: 3,
        name: "TITAN",
        description: "Gói đầu tư VIP dành cho nhà đầu tư lớn với quyền lợi đặc biệt.",
        price: "1500000000.00",
        total_slots: 30,
        used_slots: 5,
        monthly_commission_rate: "3.00",
        commission_rate: "10.00",
        commission_start_month: 1,
        duration_months: 36,
        min_profit_rate: "3.00",
        is_active: true,
        created_at: "2026-01-10T10:00:00.000000Z",
        updated_at: "2026-01-10T10:00:00.000000Z",
        image: null,
        part_per_user: 6,
        high_profit_rate: "8.00",
        high_rate_duration: 6,
        tax_rate: "10.00",
        phases: [
            {
                id: 1,
                phase_number: 1,
                title: "Xây dựng nền tảng",
                duration: "Tháng 1-12",
                description: "Phát triển hệ thống quản lý"
            }
        ],
        benefits: [
            { id: 1, description: "Tất cả quyền lợi của gói PIONEER" },
            { id: 2, description: "Cơ hội tham gia các dự án mở rộng mới với điều kiện ưu đãi" }
        ]
    }
];

export const mockStats: PlanStats = {
    total_plans: 3,
    active_plans: 3,
    total_investment: 1813000000,
    total_investors: 58
};

export const initialFormData = {
    name: '',
    description: '',
    price: 0,
    total_slots: 100,
    monthly_commission_rate: 1,
    commission_rate: 10,
    commission_start_month: 1,
    duration_months: 0,
    min_profit_rate: 0,
    is_active: true,
    part_per_user: 0,
    high_profit_rate: 4,
    high_rate_duration: 3,
    tax_rate: 10,
    image: null,
    image_preview: null,
    phases: [],
    benefits: [],
};
